// Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
export enum UserAgentDeviceType {
  MOBILE = "Mobile",
  TABLET = "Tablet",
  DESKTOP = "Desktop",
  SMARTTV = "SmartTv",
  WEARABLE = "Wearable",
}
